import React from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { useSEO } from "../components/site/Reveal";

export default function Login() {
  useSEO("Admin Login", "Administrator access for ÀsÀNigHT Worldwide.");
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center adire-bg grain-overlay px-6 py-20">
      <div className="w-full max-w-md bg-cream border border-parchment rounded-2xl p-10 shadow-2xl shadow-night/20">
        <span className="grid place-items-center w-14 h-14 rounded-full bg-forest text-cream mb-6">
          <Lock className="w-6 h-6" />
        </span>
        <h1 className="font-serif text-3xl text-ink mb-2">Admin Access</h1>
        <p className="text-ink-muted text-sm mb-8">Sign in to manage journal articles and subscribers.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-ink mb-1.5">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email-input"
              className="w-full border border-parchment rounded-md px-4 py-3 outline-none focus:border-gold focus:ring-1 focus:ring-gold bg-white"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-ink mb-1.5">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password-input"
              className="w-full border border-parchment rounded-md px-4 py-3 outline-none focus:border-gold focus:ring-1 focus:ring-gold bg-white"
            />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="w-full bg-forest text-cream font-semibold py-3.5 rounded-md hover:bg-forest-light transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
